import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IonicBaseComponent } from '@front-end/core/ionic-hooks';
import { ProjectsService } from '@front-end/core/services';

@Component({
  selector: 'ui-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarComponent extends IonicBaseComponent {
  @Input() titleKey = '';
  @Input() showCurrentProject = true;
  readonly projects$ = this.projectService.selectedProject$;
  constructor(private projectService: ProjectsService) {
    super();
  }
}
